import Cookies from "js-cookie";

const PREFERRED_PARTNER_COOKIE = "preferred_partner";

/**
 * Get the preferred partner ID from cookie (for multi-partner users)
 */
export function getPreferredPartnerId(): string | null {
	return Cookies.get(PREFERRED_PARTNER_COOKIE) ?? null;
}

/**
 * Set the preferred partner ID cookie
 */
export function setPreferredPartnerId(partnerId: string): void {
	Cookies.set(PREFERRED_PARTNER_COOKIE, partnerId, {
		expires: 365,
		path: "/",
		sameSite: "Lax",
	});
}

/**
 * Remove the preferred partner cookie
 */
export function removePreferredPartnerId(): void {
	Cookies.remove(PREFERRED_PARTNER_COOKIE, { path: "/" });
}

/**
 * Note: The main auth token (user_auth_token) is httpOnly and set by the backend.
 * We cannot read or write it from JavaScript - it's automatically sent with
 * requests when using credentials: 'include'.
 */
